<template>
  <v-dialog v-model="dialogIsOpen" :max-width="maxWidth" @click:outside="$emit('click:outside')">
    <v-card :class="$vuetify.breakpoint.lgAndUp ? 'px-10 py-8' : 'px-4 py-10'">
      <v-card-title v-if="title || this.$slots['dialog-title']" class="break-word" :class="!$vuetify.breakpoint.mdAndUp && 'px-0 mobile-title'">
        <span v-if="title" class="font-weight-bold primary--text text--darken-1 mx-auto text-center text-capitalize" :class="!$vuetify.breakpoint.mdAndUp ? 'mobile-title' : 'text-h4 '">
          {{ title }}
        </span>
        <slot v-else name="dialog-title" />
      </v-card-title>
      <v-card-text class="d-flex flex-column align-center" :class="!$vuetify.breakpoint.smAndUp && 'px-0'">
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AppDialog',

  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    maxWidth: {
      type: String,
      default: '450px'
    },
    white: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(val) {
        val || this.$emit('input', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .mobile-title {
  font-size: 1.8rem !important;
}
</style>
